import React from 'react';

const Contact: React.FC = () => {
  return (
    <div className="min-h-screen p-8">
      <h1 className="text-4xl font-bold">Contact Me</h1>
      <p>Contact page content...</p>
    </div>
  );
};

export default Contact;
